'use strict';

exports.__esModule = true;
var PROFESSIONAL_TITLES = exports.PROFESSIONAL_TITLES = {
  LOADING: 'PROFESSIONAL_TITLES_LOADING',
  SUCCEEDED: 'PROFESSIONAL_TITLES_SUCCEEDED',
  FAILED: 'PROFESSIONAL_TITLES_FAILED'
};

var loadProfessionalTitles = exports.loadProfessionalTitles = function loadProfessionalTitles(countryId /*: string*/, languageId /*: string*/) {
  return {
    type: PROFESSIONAL_TITLES.LOADING,
    countryId: countryId,
    languageId: languageId
  };
};